import { createGlobalStyle } from 'styled-components';
import Field from 'styled-up/dist/FieldContainer';

export default createGlobalStyle`
  #root {
    overflow-x: auto;
  }

  form {
    ${Field} {
      margin-bottom: 15px;

      ${Field.Head.Label} {
        color: #888 !important;
        font-weight: normal;
      }
    }
  }
`;
